import {
  IMPACT_FETCHING,
  IMPACT_SUCCESS,
  IMPACT_FAILED,
} from "../actions/types";

const initialState = {
  result: null,
  isFetching: false,
  isError: false,
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case IMPACT_FETCHING:
      return { ...state, result: null, isFetching: true, isError: false };
    case IMPACT_FAILED:
      return { ...state, result: null, isFetching: false, isError: true };
    case IMPACT_SUCCESS:
      return { ...state, result: payload, isFetching: false, isError: false };
    default:
      return state;
  }
}
